module.exports = __webpack_public_path__ + "img/Admobile2.1d6839d1.jpeg";